import { match as failedVerificationTab } from "../../../src/params/failedVerificationTab.ts";
import { match as profileImportListTab } from "../../../src/params/profileImportListTab.ts";
import { match as uuid } from "../../../src/params/uuid.ts";

export const matchers = { failedVerificationTab, profileImportListTab, uuid };